import React from "react";
import type { FC } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CoreLayout from "../layout/CoreLayout";
import Button from "../form/Button";
import { IconNewWindowLg } from "../icons";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "../../store/appStore";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {}

const Welcome: FC<Props> = () => {
	const { setSessionStatus } = useAppStore();
	const navigate = useNavigate();

	function onNext() {
		setSessionStatus('LOGIN_WAITING')
	}

	return (
		<CoreLayout>
			<div className="px-2 inline-flex flex-col justify-start items-start gap-2.5">
				<div className="justify-start text-black text-lg font-base font-['Inter']">
					Utility Account Authorization
				</div>
				<div className="justify-start text-black text-xs font-normal font-['Inter']">
					Participation in a King Energy solar energy program requires authorized access to
					your utility bill and usage data.
				</div>
				<div className="justify-start text-black text-xs font-normal font-['Inter']">
					Click the "Continue" button and follow the prompts to complete account
					authorization.
				</div>
			</div>
			<UtilityPanel title="Do you have a pge.com account?">
				<div className="grid gap-4">
					<div className="self-stretch flex flex-col justify-start items-start gap-1">
						<div className="justify-start text-black text-xs font-normal font-['Inter']">
							Yes:
						</div>
						<Button onClick={onNext} type="secondary" className="w-[200px]">
							Continue to login
						</Button>
					</div>
					<div className="self-stretch flex flex-col justify-start items-start gap-1">
						<div className="justify-start text-black text-xs font-normal font-['Inter']">
							Yes, but I don't remember my pge.com password:
						</div>
						<Button
							onClick={() => {
								window.open(
									"https://pge.com/eimp/?appname=MyAccount&returnURL=https%3A%2F%2Fm.pge.com#forgotPassword",
									"_blank",
								);
							}}
							type="secondary"
							subType="outline"
							className="min-w-[200px]"
						>
							Reset password <IconNewWindowLg />
						</Button>
					</div>
					<div className="self-stretch flex flex-col justify-start items-start gap-1">
						<div className="justify-start text-black text-xs font-normal font-['Inter']">
							Yes, but I don't remember my pge.com username:
						</div>
						<Button
							onClick={() => {
								window.open(
									"https://pge.com/eimp/?appname=MyAccount&returnURL=https%3A%2F%2Fm.pge.com#forgotUserName",
									"_blank",
								);
							}}
							type="secondary"
							subType="outline"
							className="min-w-[200px]"
						>
							Retrieve username <IconNewWindowLg />
						</Button>
					</div>
					<div className="self-stretch flex flex-col justify-start items-start gap-1">
						<div className="justify-start text-black text-xs font-normal font-['Inter']">
							No, I need to create a pge.com account:
						</div>
						<Button
							onClick={() => {
								window.open("https://m.pge.com/#registration", "_blank");
							}}
							type="secondary"
							subType="outline"
							className="min-w-[200px]"
						>
							Create account <IconNewWindowLg />
						</Button>
					</div>
				</div>
			</UtilityPanel>
		</CoreLayout>
	);
};

export default withErrorBoundary(Welcome);
